import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

function SectionJoin() {
  const { t } = useTranslation();

  return (
    <section id="contact" className="py-6 md:py-10 px-6 bg-[#16592E] text-center">
      <h1 className="text-[38px] md:text-[46px] text-[#FAF9F6E5] font-[CormorantGaramond] font-bold">
        {t('landing.join.title')}
      </h1>
      <p className="text-[#FAF9F6E5] text-[15px] pt-3 pb-8 font-light">
        {t('landing.join.subtitle')}
      </p>
      <Link
        to="/register?type=provider"
        className="inline-block bg-[#0D7330] py-2 px-[26px] text-white text-[17px] rounded-[10px] shadow-become hover:opacity-90 transition-opacity"
      >
        {t('landing.join.cta')}
      </Link>
    </section>
  );
}

export default SectionJoin;
